import React from "react";
import { useEffect } from "react";
import { uuidv4 } from "../../../Editor/utils";
import TinyMCEEditor from "../../TinyMCEEditor";
import deleteIcon from '../../../assests/delete-action.png'
import classes from './QuestionOptions.module.css'
import { useSelector } from "react-redux";

const QuestionOptions = ({ options, multiple, survey, index, onDataChange, id }) => {

    const { texts } = useSelector(state => state.translate);

    useEffect(() => {
        // for change from multiple true to false 
        if (multiple === false) {
            const correctAnsNum = options.filter(opt => opt.correct);
            if (correctAnsNum && correctAnsNum.length > 1) {
                onDataChange({ options: options.map(opt => ({ ...opt, correct: false })) })
            }
        }
    }, [multiple])

    useEffect(() => {
        // treat for the data before add id (in the past was by index)
        if (options?.length > 0 && !options[0]?.id) {
            let newOptions = options.map(o => ({ ...o, id: uuidv4() }))
            onDataChange({ options: newOptions })
        }
    }, [id])

    const handleChangeOption = (id, key, value) => {
        let newOptions = [...options];
        const index = newOptions.findIndex(o => o.id == id)
        if (index !== -1) {
            if (key === 'correct' && !multiple) {
                newOptions = newOptions.map(opt => ({ ...opt, correct: false }))
            }
            newOptions[index] = { ...newOptions[index] };
            newOptions[index][key] = value;
            onDataChange({ options: newOptions })
        }
    }

    const handleAddOption = () => {
        let newOptions = [...options, { correct: false, content: "", id: uuidv4() }];
        onDataChange({ options: newOptions })
    }
    const handleDeleteOption = (id) => {
        let newOptions = options.filter(o => o.id != id)
        onDataChange({ options: newOptions })
    }

    return <div className={classes.QuestionOptions}>
        <div className={classes.OptionsList}>
            {options && options.map((opt, indexOpt) => <div className={classes.Option} key={opt.id}>
                <div className={classes.OptionCheck}>{ !survey &&<input value={opt.correct} checked={opt.correct} type={multiple ? 'checkbox' : 'radio'} name={index + 'check-quetion-option'} onChange={(e) => handleChangeOption(opt.id, 'correct', e.target.checked)}></input>}</div>
                <div className={classes.OptionContent}><TinyMCEEditor id={`${id}b${indexOpt}`} data={opt.content} inline={true} setContentData={(content) => handleChangeOption(opt.id, 'content', content)}> </TinyMCEEditor></div>
                <img className={classes.DeleteOption} onClick={() => handleDeleteOption(opt.id)} value={"מחק"} src={deleteIcon} alt="DeleteIcon" />
            </div>)}
            <div className={classes.New}><button onClick={handleAddOption}>{texts.addOption}</button></div>
        </div>
    </div>

}
export default QuestionOptions;